 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"networks-invite":"networks-invite","auth":"auth","all-colleagues":"all-colleagues","profile":"profile","courses":"courses"}[chunkId]||chunkId) + "." + {"chunk-2d0c1f37":"b9cb2460","chunk-2d210a64":"87fda747","chunk-2d0e946f":"07ed9673","chunk-2d21b8bc":"6b8503fc","chunk-2d221bf8":"737017aa","chunk-51001666":"06d056c1","chunk-5bec6d44":"db7984ec","networks-invite":"8f62767f","auth":"b8ead7d6","chunk-0e79300c":"b2f30017","chunk-1d2a3322":"daaba3d2","chunk-26cb497d":"277f2e03","chunk-28170234":"0000ea41","chunk-2d0e17d2":"c5339bad","chunk-3787fd5d":"2162d323","chunk-30ca15a1":"f1fd7e48","chunk-7ad8a84e":"7e11029b","chunk-3420681c":"ca7e2b88","chunk-54e6e8bc":"961edf1f","chunk-4a3b1baa":"0d7f6a23","chunk-4b7f2633":"72026110","chunk-4f32c61c":"4f9d086a","chunk-2354caf9":"f1b1aa74","chunk-451bbb98":"f7e1d766","chunk-3bbe93ec":"066a0568","chunk-58c824d4":"c730d7af","chunk-58d37656":"85c37313","chunk-6c83e519":"bc177bef","chunk-f9e59d4a":"38d9ef29","chunk-d6a3e1ac":"8658c5e4","chunk-6f05421b":"193a8629","chunk-74e02ef6":"2b8d8ad3","chunk-bf323570":"f5a9e0f1","chunk-10d66164":"98a12df1","chunk-423cf025":"e3ad04d3","chunk-91097270":"ad556cec","chunk-f6f51e34":"a3a49bba","chunk-e71de536":"c8523e16","chunk-2486b75c":"93ac888a","chunk-ccbc78ae":"ff930ab1","chunk-d8873f98":"2c9bd096","chunk-3ec86831":"1512d49f","chunk-9401496e":"d988aa96","chunk-f2506476":"7530ad93","all-colleagues":"730daccb","chunk-28726dfa":"264ff701","chunk-2dd7ee3a":"d869e363","chunk-64a6651c":"5cb6fade","chunk-3096ba50":"7c236f20","profile":"7b925dd1","chunk-f50b3500":"9ae93a1b","chunk-da8eb716":"47f86ebc","chunk-61c3a5eb":"9f6b39cf","chunk-2f5353f6":"9f9d457c","chunk-1b6c8102":"ef832d00","courses":"f5a1e4b5","chunk-0482c30c":"8c526ba4","chunk-05fa33f5":"2d6b364d","chunk-1b74c1c6":"1947ea3a","chunk-341c95c8":"20b7a425","chunk-e944d3f6":"8989eb81","chunk-301c8561":"3c046049","chunk-9a6102b0":"8ced7e56","chunk-97d5336a":"7aaf2e90","chunk-fa5681d4":"7d0dfdd4","chunk-2d0e1fb0":"4727eb92","chunk-1cf2cb6d":"e927c32b","chunk-2d0aaf64":"62f49adb","chunk-2d0c7ce2":"c75b2bd6","chunk-2d210457":"e7848a15","chunk-2d21a33c":"87375ed4","chunk-2d21e75b":"d83d27b4","chunk-719cec34":"de4d1a68","chunk-2d0c91c9":"977e60e7","chunk-1087f333":"d2506ead"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"styles"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
